import { Axios } from '@/config/axios'

const state = {
    notifications: [],
    unreadCount: 0,
    productCommunications: [],
    unreadProductCommunicationsCount: 0,
    alerts: [],
    totalAlerts: 0
}

const getters = {
    getNotifications: state => state.notifications,
    getUnreadCount: state => state.unreadCount,
    getProductCommunications: state => state.productCommunications,
    getUnreadProductCommunicationsCount: state => state.unreadProductCommunicationsCount,
    getAlerts: state => state.alerts,
    getTotalAlerts: state => state.totalAlerts
}

const actions = {
    getNotifications({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/notifications?page=${data.page}&perPage=${data.perPage}`)
                .then((response) => {
                    commit('SET_NOTIFICATIONS', response.data.data)
                    commit('SET_UNREAD_COUNT', response.data.unread_count)
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    
    markAsRead({ commit }, notificationId) {
        return new Promise((resolve, reject) => {
            Axios.put(`/api/notifications/${notificationId}/read`)
                .then((response) => {
                    commit('MARK_AS_READ', notificationId)
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    getProductCommunications({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/product-communications?page=${data.page}&perPage=${data.perPage}`)
                .then((response) => {
                    commit('SET_PRODUCT_COMMUNICATIONS', response.data.data)
                    commit('SET_UNREAD_PRODUCT_COMMUNICATIONS_COUNT', response.data.unread_count)
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    markProductCommunicationAsRead({ commit }, communicationId) {
        return new Promise((resolve, reject) => {
            Axios.put(`/api/product-communications/${communicationId}/read`)
                .then((response) => {
                    commit('MARK_PRODUCT_COMMUNICATION_AS_READ', communicationId)
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    getCommunicationSettings({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/communication-settings`)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    updateCommunicationSettings({ commit }, settings) {
        return new Promise((resolve, reject) => {
            Axios.put(`/api/communication-settings`, settings)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    getAlerts({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/alerts?page=${data.page}&perPage=${data.perPage}&agentId=${data.agentId}&ohpEuid=${data.adminOhpEuid}`)
                .then((response) => {
                    commit('SET_ALERTS', response.data.data.data)
                    commit('SET_TOTAL_ALERTS', response.data.data.total)
                    resolve(response.data.data)
                })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },
    SET_UNREAD_COUNT(state, count) {
        state.unreadCount = count
    },
    MARK_AS_READ(state, notificationId) {
        const notification = state.notifications.find(n => n.id === notificationId)
        if (notification) {
            notification.is_read = true
            state.unreadCount = Math.max(0, state.unreadCount - 1)
        }
    },
    SET_PRODUCT_COMMUNICATIONS(state, communications) {
        state.productCommunications = communications
    },
    SET_UNREAD_PRODUCT_COMMUNICATIONS_COUNT(state, count) {
        state.unreadProductCommunicationsCount = count
    },
    MARK_PRODUCT_COMMUNICATION_AS_READ(state, communicationId) {
        const communication = state.productCommunications.find(c => c.id === communicationId)
        if (communication) {
            communication.is_read = true
            state.unreadProductCommunicationsCount = Math.max(0, state.unreadProductCommunicationsCount - 1)
        }
    },
    SET_ALERTS(state, alerts) {
        state.alerts = alerts
    },
    SET_TOTAL_ALERTS(state, total) {
        state.totalAlerts = total
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}